var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.app_loading)?_c('div',{staticClass:"loading-layer"},[_c('svg',{attrs:{"height":"56","viewBox":"0 0 56 56","width":"72"}},[_c('g',[_c('circle',{attrs:{"cx":"28","cy":"28","id":"spinner","r":"25"}})])])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }